<template>
	<div>
		<div class="omapi-pagination omapi-pagination__style-1">
			<span class="omapi-pagination__total">
				<slot>{{ output }}</slot>
			</span>
			<template v-if="totalPages > 1">
				<core-button
					type="secondary"
					class="omapi-pagination__button omapi-pagination__button-symbol"
					:disabled="isFirstPage"
					@click="changePage(1)"
					>«</core-button
				>
				<core-button
					type="secondary"
					class="omapi-pagination__button omapi-pagination__button-symbol"
					:disabled="isFirstPage"
					@click="changePage(page - 1)"
					>‹</core-button
				>
				<input
					v-model="pageVal"
					type="text"
					class="omapi-pagination__input"
					size="1"
					@change="changePage($event.target.value)"
				/>
				<div class="omapi-pagination__text">of {{ totalPages }}</div>
				<core-button
					type="secondary"
					class="omapi-pagination__button omapi-pagination__button-symbol"
					:disabled="isLastPage"
					@click="changePage(page + 1)"
					>›</core-button
				>
				<core-button
					type="secondary"
					class="omapi-pagination__button omapi-pagination__button-symbol"
					:disabled="isLastPage"
					@click="changePage(totalPages)"
					>»</core-button
				>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		perPage: {
			type: Number,
			default: 20,
		},
		pageTotal: {
			type: Number,
			default: 0,
		},
		total: {
			type: Number,
			default: 0,
		},
		page: {
			type: Number,
			default: 1,
		},
		label: {
			type: String,
			default: 'Item',
		},
	},
	data() {
		return {
			pageVal: this.page,
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.total / this.perPage);
		},
		isFirstPage() {
			return 2 > this.page;
		},
		isLastPage() {
			return this.page === this.totalPages;
		},
		output() {
			let output = `${this.pageTotal}  ${this.label}`;

			if (1 < this.pageTotal) {
				output += 's';
			}

			return output;
		},
	},
	watch: {
		page() {
			this.pageVal = this.page;
		},
	},
	methods: {
		changePage(page) {
			page = parseInt(page, 10);
			if (Number.isNaN(page)) {
				this.pageVal = this.page;
				return;
			}

			if (this.totalPages < page) {
				page = this.totalPages;
			}
			if (1 > page) {
				page = 1;
			}

			this.$emit('changePage', page);
		},
	},
};
</script>
